import React, { useState } from "react";

import { Notifications } from "@mui/icons-material";
import {
  Badge,
  IconButton,
  Menu,
  useMediaQuery,
  useTheme
} from "@mui/material";

import { theme as appTheme } from "@/src/theme/theme";

import { useAuth } from "@/src/auth/hooks/useAuth";

import { useGetNotifications } from "../../../queries/notifications/notificationQueries";
import NotificationPanel from "./NotificationPanel";

const NotificationMenu = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { isAuthenticated } = useAuth();

  const open = Boolean(anchorEl);

  const { data } = useGetNotifications(isAuthenticated);
  const notifications = data ?? [];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setAnchorEl(null);
  };

  const unreadNotifications = notifications.filter(({ isRead }) => !isRead);

  return (
    <>
      <IconButton
        sx={{
          backgroundColor: open ? theme.palette.misc.outlineBorder : undefined
        }}
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <Badge
          variant="standard"
          color="secondary"
          badgeContent={unreadNotifications.length}
          sx={{
            "& .MuiBadge-badge": {
              borderRadius: "60%",
              right: 4,
              top: 3,
              minWidth: "18px",
              height: "18px",
              fontSize: (theme) => theme.typography.caption.fontSize,
              px: 0.5,
              py: 0
            }
          }}
        >
          <Notifications
            sx={{ color: appTheme.palette.semantic.primary.contrastText }}
          />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        onClose={handleClose}
      >
        <NotificationPanel
          isMobile={isMobile}
          notifications={notifications}
          handleCloseMenu={handleClose}
        />
      </Menu>
    </>
  );
};

export default NotificationMenu;
